import AppHeader from '../app/appHeader';
import React, { FC, useEffect, useState } from 'react';
import './styles/registration.scss';
import { InfoInactiveIcon } from '@getgo/chameleon-icons/react';
import { Alert, Typography } from '@getgo/chameleon-web/react';
import Footer from '../footer/footer';
import { useTranslation } from 'react-i18next';
import { useEventContext } from '../context/eventContext';
import { useParams } from 'react-router';
import { IEventUrlParameters } from '../event/eventInterface';
import API from '../utils/api';
import FullScreenLoader from '../utils/fullScreenLoader/FullScreenLoader';

const SuccessRegistration: FC = () => {
  const { t, i18n } = useTranslation();
  const [isLoading, setLoading] = useState<boolean>(true);
  const { eventId } = useParams<IEventUrlParameters>();
  const { setEventDetails, eventDetails } = useEventContext();

  useEffect(() => {
    if (!eventDetails) {
      const getEvent = async () => {
        const eventData = await API.getEventDetails(eventId || '');
        const lang = eventData?.data?.locale?.substr(0, 2).toLowerCase() || 'en';
        if (lang && lang !== i18n.language) {
          i18n.changeLanguage(lang, () => {
            let langCopy = lang;
            if (langCopy === 'zh') {
              langCopy = 'zh-cn';
            }
            // TO-DO Change language for date
            document.documentElement.lang = langCopy;
          });
        }
        if (eventData.status === 200) {
          setEventDetails(eventData.data);
        }
      };
      getEvent();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventDetails]);

  useEffect(() => {
    if (eventDetails?.locale.includes(i18n.language)) {
      setLoading(false);
    }
  }, [eventDetails?.locale, i18n.language]);

  return isLoading ? (
    <FullScreenLoader />
  ) : (
    <div className="success-registration-grid">
      <AppHeader />
      <div className="success-registration">
        <div className="box">
          <div className="box-space">
            <div>
              <Typography color="text-01" variant="heading-large">
                {t('successRegistration.title')}
              </Typography>
            </div>
            <div className="success-registration-description">
              <Typography color="text-01" variant="body-large">
                {t('successRegistration.description')}
              </Typography>
            </div>
          </div>
          <Alert icon={<InfoInactiveIcon />}>
            <Typography color="text-01">{t('successRegistration.alertText')}</Typography>
          </Alert>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SuccessRegistration;
